module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/modules/_redefine.js
// module id = ../../../node_modules/core-js/library/modules/_redefine.js
// module chunks = 0